import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ServerPageProvider, {
	ServerPageProviderProps,
	SppData,
} from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { Lang } from '@common/typescript/objects/Lang';
import { useItemProviderContext } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';

interface Props<T extends SppData = SppData> extends Omit<ServerPageProviderProps<T>, 'language'> {}

const ServerPageInner: React.FC<{language}> = ({ language }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const { state: { loading, item, error } } = useItemProviderContext<any>();

	React.useEffect(() => {
		const newPath = `${language === Lang.Es ? '/es' : ''}/${item?.fullPath === 'home' ? ''
			: language === Lang.Es ? item?.fullPathEs : item?.fullPath}`;
		if (item && location.pathname !== newPath && !loading && !error) {
			navigate({
				...location,
				pathname: newPath,
			}, { replace: true });
		}
	}, [language]);

	return <></>;
};

const ServerPageProviderWithLang = <T extends SppData>(props: Props<T>) => {
	const context = useApplicationContext();
	const lang = context?.getLang() ?? Lang.En;
	return <ServerPageProvider<T>
		language={lang}
		{...props}
	>
		<ServerPageInner language={lang} />
	</ServerPageProvider>;
};

export default ServerPageProviderWithLang;
